// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/VectorBack.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/print.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/select.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addMultiProductDrawer_drawer__AKUS2 {
  z-index: 0;
  position: fixed;
  top: 0;
  right: 0;
  width: 85vw;
  height: 100vh;
  background: rgba(249, 249, 249, 1);
  z-index: 1000;
  padding: 50px 32px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.addMultiProductDrawer_header__Pjtve {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.addMultiProductDrawer_headerText__QpeRZ {
  font-weight: 700;
  font-size: 24px;
  margin-left: 12px;
}

.addMultiProductDrawer_closeButton__BJ\\+em {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  width: 15px;
  height: 16.2px;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.addMultiProductDrawer_body__AGD\\+H {
  width: 50%;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  padding: 24px;
  text-align: left;
}

.addMultiProductDrawer_body__AGD\\+H h3 {
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 700;
}

.addMultiProductDrawer_grid__NWyNj {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.addMultiProductDrawer_formSection__R3bxr {
  margin-bottom: 30px;
}

.addMultiProductDrawer_row__QEFNb {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}

.addMultiProductDrawer_input__LqHLz{
  padding: 0 10px;
  border: 1px solid rgba(203, 213, 225, 1) ;
  border-radius: 6px ;
  font-size: 14px ;
}

.addMultiProductDrawer_photoUpload__HgLhL {
  border: 1px dashed #ccc;
  padding: 20px;
  text-align: center;
}

.addMultiProductDrawer_link__HoC78 {
  background: none;
  border: none;
  color: green;
  cursor: pointer;
}

.addMultiProductDrawer_generate__op8gr {
  margin-top: 10px;
}

.addMultiProductDrawer_footer__uODxY {
  text-align: right;
}

.addMultiProductDrawer_submit__9a0Lp {
  padding: 10px 20px;
  background: green;
  color: white;
  border: none;
  border-radius: 5px;
}

.addMultiProductDrawer_section__saxjO {
  margin-bottom: 24px;
}

.addMultiProductDrawer_section__saxjO h3 {
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 700;
}

.addMultiProductDrawer_barcodeRow__LfZ2q {
  display: flex;
  align-items: center;
  gap: 12px;
}

.addMultiProductDrawer_barcodeRowBlock__ZoEi- {
  position: relative;
  display: inline-block;
}

.addMultiProductDrawer_barcodeRowBlock__ZoEi-::after {
  content: '';
  position: absolute;
  bottom: 10px;
  right: 12px;
  height: 16px;
  width: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: contain;
  pointer-events: none;
}

.addMultiProductDrawer_barcodeRowBlock__ZoEi- input {
  width: 310px;
}

.addMultiProductDrawer_barcodeRowRandom__4Gg6N {
  color: rgba(29, 135, 82, 1);
  font-size: 16px;
  margin-top: 4px;
}

.addMultiProductDrawer_input__LqHLz{
  padding: 10px ;
  border: 1px solid rgba(203, 213, 225, 1) ;
  border-radius: 6px ;
  font-size: 14px ;
}


.addMultiProductDrawer_uploadBox__Lab\\+F {
  display: flex;
}

.addMultiProductDrawer_uploadPlaceholder__qV2sN {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 160px;
  border: 1px dashed #ccc;
  border-radius: 8px;
  font-size: 16px;
  color: rgba(29, 135, 82, 1);
  margin-bottom: 8px;
}

.addMultiProductDrawer_uploadPlaceholderPlus__C3cUE {
  font-size: 40px;
}

.addMultiProductDrawer_uploadInfo__XLRhT {
  font-size: 14px;
  line-height: 24px;
  padding-left: 16px;
}

.addMultiProductDrawer_stepIndicator__d0vKx {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.addMultiProductDrawer_stepItem__wWrn6 {
  display: flex;
  align-items: center;
}

.addMultiProductDrawer_circle__6mWNc {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: lightgray;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
}

.addMultiProductDrawer_stepLabel__8TVFa {
  margin-left: 6px;
  font-size: 14px;
  color: #ccc;
}

.addMultiProductDrawer_active__O-WIe .addMultiProductDrawer_circle__6mWNc {
  background: rgba(29, 135, 82, 1); /* Зеленый круг */
}

.addMultiProductDrawer_active__O-WIe .addMultiProductDrawer_stepLabel__8TVFa {
  color: rgba(29, 135, 82, 1); /* Зеленый текст */
}

.addMultiProductDrawer_stepLine__-QZBk {
  width: 32px;
  height: 2px;
  background: #ccc;
  margin: 0 10px;
}

.addMultiProductDrawer_footer__uODxY {
    display: flex;
    justify-content: space-between;
}

.addMultiProductDrawer_back__GxOlA {
    padding: 0 24px;
    color: rgba(115, 115, 115, 1);
    background: none;
    border: 1px solid rgba(115, 115, 115, 1);
    border-radius: 5px;
}
.addMultiProductDrawer_myButtonClass__2GIE7 {
  font-size: 16px;
  color: rgba(29, 135, 82, 1);
  position: relative;
  padding-right: 20px;
  margin-bottom: 150px;
  background: none;
  border: none;
  cursor: pointer;
}

.addMultiProductDrawer_myButtonClass__2GIE7::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 13.5px;
  height: 7.5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); 
  background-size: contain;
  background-repeat: no-repeat;
}

.addMultiProductDrawer_characteristicSection__qHKPw {
  margin-top: 20px;
}

.addMultiProductDrawer_inputRow__wBeRJ {
  display: flex;
  align-items: end;
  gap: 10px;
}

.addMultiProductDrawer_input__LqHLz {
  flex-grow: 1;
  padding: 8px;
  font-size: 14px;
}

.addMultiProductDrawer_deleteButton__fjthr {
  background: #e74c3c;
  border: none;
  color: white;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
}

.addMultiProductDrawer_buttonsRow__u\\+A\\+V {
  margin-top: 15px;
  display: flex;
  gap: 10px;
}

.addMultiProductDrawer_addValueButton__J24re,
.addMultiProductDrawer_addCharacteristicButton__PIFHw {
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  background-color: #1d8752; /* например зеленый */
  color: white;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/addMultiProductDrawer.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;IACI,yDAA6C;EAC/C,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yDAA0C;EAC1C,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gCAAgC,EAAE,iBAAiB;AACrD;;AAEA;EACE,2BAA2B,EAAE,kBAAkB;AACjD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;AACtB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,yDAA2C;EAC3C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB,EAAE,qBAAqB;EAChD,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".drawer {\n  z-index: 0;\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 85vw;\n  height: 100vh;\n  background: rgba(249, 249, 249, 1);\n  z-index: 1000;\n  padding: 50px 32px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.headerText {\n  font-weight: 700;\n  font-size: 24px;\n  margin-left: 12px;\n}\n\n.closeButton {\n    background-image: url(/public/VectorBack.png);\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 15px;\n  height: 16.2px;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.body {\n  width: 50%;\n  background-color: rgba(255, 255, 255, 1);\n  border-radius: 12px;\n  padding: 24px;\n  text-align: left;\n}\n\n.body h3 {\n  margin-bottom: 16px;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n.formSection {\n  margin-bottom: 30px;\n}\n\n.row {\n  display: flex;\n  gap: 20px;\n  margin-top: 10px;\n}\n\n.input{\n  padding: 0 10px;\n  border: 1px solid rgba(203, 213, 225, 1) ;\n  border-radius: 6px ;\n  font-size: 14px ;\n}\n\n.photoUpload {\n  border: 1px dashed #ccc;\n  padding: 20px;\n  text-align: center;\n}\n\n.link {\n  background: none;\n  border: none;\n  color: green;\n  cursor: pointer;\n}\n\n.generate {\n  margin-top: 10px;\n}\n\n.footer {\n  text-align: right;\n}\n\n.submit {\n  padding: 10px 20px;\n  background: green;\n  color: white;\n  border: none;\n  border-radius: 5px;\n}\n\n.section {\n  margin-bottom: 24px;\n}\n\n.section h3 {\n  margin-bottom: 16px;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.barcodeRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.barcodeRowBlock {\n  position: relative;\n  display: inline-block;\n}\n\n.barcodeRowBlock::after {\n  content: '';\n  position: absolute;\n  bottom: 10px;\n  right: 12px;\n  height: 16px;\n  width: 16px;\n  background-image: url('/public/print.png');\n  background-repeat: no-repeat;\n  background-size: contain;\n  pointer-events: none;\n}\n\n.barcodeRowBlock input {\n  width: 310px;\n}\n\n.barcodeRowRandom {\n  color: rgba(29, 135, 82, 1);\n  font-size: 16px;\n  margin-top: 4px;\n}\n\n.input{\n  padding: 10px ;\n  border: 1px solid rgba(203, 213, 225, 1) ;\n  border-radius: 6px ;\n  font-size: 14px ;\n}\n\n\n.uploadBox {\n  display: flex;\n}\n\n.uploadPlaceholder {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 160px;\n  height: 160px;\n  border: 1px dashed #ccc;\n  border-radius: 8px;\n  font-size: 16px;\n  color: rgba(29, 135, 82, 1);\n  margin-bottom: 8px;\n}\n\n.uploadPlaceholderPlus {\n  font-size: 40px;\n}\n\n.uploadInfo {\n  font-size: 14px;\n  line-height: 24px;\n  padding-left: 16px;\n}\n\n.stepIndicator {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 12px;\n}\n\n.stepItem {\n  display: flex;\n  align-items: center;\n}\n\n.circle {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: lightgray;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.stepLabel {\n  margin-left: 6px;\n  font-size: 14px;\n  color: #ccc;\n}\n\n.active .circle {\n  background: rgba(29, 135, 82, 1); /* Зеленый круг */\n}\n\n.active .stepLabel {\n  color: rgba(29, 135, 82, 1); /* Зеленый текст */\n}\n\n.stepLine {\n  width: 32px;\n  height: 2px;\n  background: #ccc;\n  margin: 0 10px;\n}\n\n.footer {\n    display: flex;\n    justify-content: space-between;\n}\n\n.back {\n    padding: 0 24px;\n    color: rgba(115, 115, 115, 1);\n    background: none;\n    border: 1px solid rgba(115, 115, 115, 1);\n    border-radius: 5px;\n}\n.myButtonClass {\n  font-size: 16px;\n  color: rgba(29, 135, 82, 1);\n  position: relative;\n  padding-right: 20px;\n  margin-bottom: 150px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.myButtonClass::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 13.5px;\n  height: 7.5px;\n  background-image: url('/public/select.png'); \n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.characteristicSection {\n  margin-top: 20px;\n}\n\n.inputRow {\n  display: flex;\n  align-items: end;\n  gap: 10px;\n}\n\n.input {\n  flex-grow: 1;\n  padding: 8px;\n  font-size: 14px;\n}\n\n.deleteButton {\n  background: #e74c3c;\n  border: none;\n  color: white;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.buttonsRow {\n  margin-top: 15px;\n  display: flex;\n  gap: 10px;\n}\n\n.addValueButton,\n.addCharacteristicButton {\n  padding: 8px 16px;\n  border: none;\n  cursor: pointer;\n  background-color: #1d8752; /* например зеленый */\n  color: white;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `addMultiProductDrawer_drawer__AKUS2`,
	"header": `addMultiProductDrawer_header__Pjtve`,
	"headerText": `addMultiProductDrawer_headerText__QpeRZ`,
	"closeButton": `addMultiProductDrawer_closeButton__BJ+em`,
	"body": `addMultiProductDrawer_body__AGD+H`,
	"grid": `addMultiProductDrawer_grid__NWyNj`,
	"formSection": `addMultiProductDrawer_formSection__R3bxr`,
	"row": `addMultiProductDrawer_row__QEFNb`,
	"input": `addMultiProductDrawer_input__LqHLz`,
	"photoUpload": `addMultiProductDrawer_photoUpload__HgLhL`,
	"link": `addMultiProductDrawer_link__HoC78`,
	"generate": `addMultiProductDrawer_generate__op8gr`,
	"footer": `addMultiProductDrawer_footer__uODxY`,
	"submit": `addMultiProductDrawer_submit__9a0Lp`,
	"section": `addMultiProductDrawer_section__saxjO`,
	"barcodeRow": `addMultiProductDrawer_barcodeRow__LfZ2q`,
	"barcodeRowBlock": `addMultiProductDrawer_barcodeRowBlock__ZoEi-`,
	"barcodeRowRandom": `addMultiProductDrawer_barcodeRowRandom__4Gg6N`,
	"uploadBox": `addMultiProductDrawer_uploadBox__Lab+F`,
	"uploadPlaceholder": `addMultiProductDrawer_uploadPlaceholder__qV2sN`,
	"uploadPlaceholderPlus": `addMultiProductDrawer_uploadPlaceholderPlus__C3cUE`,
	"uploadInfo": `addMultiProductDrawer_uploadInfo__XLRhT`,
	"stepIndicator": `addMultiProductDrawer_stepIndicator__d0vKx`,
	"stepItem": `addMultiProductDrawer_stepItem__wWrn6`,
	"circle": `addMultiProductDrawer_circle__6mWNc`,
	"stepLabel": `addMultiProductDrawer_stepLabel__8TVFa`,
	"active": `addMultiProductDrawer_active__O-WIe`,
	"stepLine": `addMultiProductDrawer_stepLine__-QZBk`,
	"back": `addMultiProductDrawer_back__GxOlA`,
	"myButtonClass": `addMultiProductDrawer_myButtonClass__2GIE7`,
	"characteristicSection": `addMultiProductDrawer_characteristicSection__qHKPw`,
	"inputRow": `addMultiProductDrawer_inputRow__wBeRJ`,
	"deleteButton": `addMultiProductDrawer_deleteButton__fjthr`,
	"buttonsRow": `addMultiProductDrawer_buttonsRow__u+A+V`,
	"addValueButton": `addMultiProductDrawer_addValueButton__J24re`,
	"addCharacteristicButton": `addMultiProductDrawer_addCharacteristicButton__PIFHw`
};
export default ___CSS_LOADER_EXPORT___;
